import Tips from 'components/RecurringOrderSuggestionsModal/Sections/Tips/styled';

export default Tips;
